import React from 'react';
import s from './Pagination.module.css';

const SIZES = [10, 25, 50, 100];

// The table footer: page size, the range being shown, and the page controls.
//
// Presentational — it computes nothing beyond the labels it prints. The page
// that owns the rows owns the slicing, because it is the one that knows what a
// row is.
export default function Pagination({
  page,
  pageCount,
  perPage,
  total,
  onPageChange,
  onPerPageChange,
}) {
  const first = total ? (page - 1) * perPage + 1 : 0;
  const last = Math.min(page * perPage, total);

  return (
    <div className={s.foot}>
      <span>Items per page</span>
      <select
        className={s.control}
        value={perPage}
        onChange={(e) => onPerPageChange(Number(e.target.value))}
      >
        {SIZES.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>

      <span>{first} – {last} in {total}</span>
      <span className={s.spacer} />

      <button className={s.control} disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
      <span>{page}</span>
      <button className={s.control} disabled={page >= pageCount} onClick={() => onPageChange(page + 1)}>›</button>

      <span className={s.spacer} />
      <span>Go to page:</span>
      <select className={s.control} value={page} onChange={(e) => onPageChange(Number(e.target.value))}>
        {Array.from({ length: pageCount }, (_, i) => i + 1)
          .map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
      <span>of {pageCount} page{pageCount === 1 ? '' : 's'}</span>
    </div>
  );
}
